import { useState, useEffect } from "react";

const SIDEBAR_STATE_KEY = "maitai-assistant-sidebar-state";

export const useAssistantSidebar = () => {
  // Initialize state from localStorage
  const [showSidebar, setShowSidebar] = useState<boolean>(() => {
    const stored = localStorage.getItem(SIDEBAR_STATE_KEY);
    return stored ? JSON.parse(stored) : false;
  });

  // Persist state to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem(SIDEBAR_STATE_KEY, JSON.stringify(showSidebar));
  }, [showSidebar]);

  const toggleSidebar = () => {
    setShowSidebar(prev => !prev);
  };

  return { showSidebar, setShowSidebar, toggleSidebar };
};
